// extracted by mini-css-extract-plugin
export default {"page":"Packages_page__pozAW","container":"Packages_container__97drF","header":"Packages_header__8Lasl"};